import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { fetchIndividualConsultationFormResponse, updateIndividualConsultationFormResponse, undoSubmitIndividualConsultationFormResponse } from './actions';
import { withTranslation } from 'react-i18next';
import Components from '../assessmentForms/Components';
import IndividualConsultationForm from '../assessmentForms/Form';
import BackButton from '../../common/components/BackButton';
import { SubmissionError } from 'redux-form';
import authUtils from '../../auth/utils';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

class FormDetails extends Component {
	constructor(props) {
		super(props);
		this.handleUndoSubmit = this.handleUndoSubmit.bind(this);
	}

	componentDidMount() {
		this.props.fetchIndividualConsultationFormResponse(Number(this.props.match.params.id));
	}

	handleFormSubmit(values, isFinal, requiredFields, validationFunc) {
		const { t } = this.props;

		if (isFinal) {
			let errors = {};
			if (requiredFields) {
				requiredFields.forEach(field => {
					if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
						errors[field] = t('Validator_Required');
					}
				});
			}

			if (validationFunc) {
				errors = Object.assign(errors, validationFunc(values, t));
			}

			// throw redux-form error if fields are missing when submiting form in Final status
			if (Object.keys(errors).length > 0) {
				toast.error(t('IndividualConsultationForm_ValidationErrors'));
				throw new SubmissionError(errors);
			}
		}

		let notes = values.notes;
		values.notes = undefined;
		this.props.updateIndividualConsultationFormResponse(Number(this.props.match.params.id), { content: values, notes, isFinal },
			() => toast.success(t(isFinal ? 'IndividualConsultationForm_Final_Saved' : 'IndividualConsultationForm_Draft_Saved')),
			(errorMessage) => toast.error(errorMessage));
	}

	handleUndoSubmit() {
		const { t } = this.props;
		this.props.undoSubmitIndividualConsultationFormResponse(this.props.match.params.id, () => toast.success(t('IndividualConsultationForm_UndoSubmited')),
			(errorMessage) => toast.error(errorMessage));
	}

	render() {
		const { form, isReadonly, currentFormValues, changeFormValue, allowUndoSubmit,  t } = this.props;
		const { component, requiredFields, validationFunc } = form ? Components(form, currentFormValues, changeFormValue) : {
			component: null, requiredFields: [], validationFunc: null
		};

		let values = form && form.content;

		if (values) {
			values.notes = form && form.notes;
		}

		let formName = form && form.form && form.form.name;
		return <div>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			{form && <IndividualConsultationForm
				title={formName && t(`AssessmentForm_Consultation_${formName}`)}
				formComponent={component}
				initialValues={values}
				onSubmit={(values, isFinal) => this.handleFormSubmit(values, isFinal, requiredFields, validationFunc)}
				isReadonly={isReadonly || !form.form.isTeacherForm || form.status.id === 3} //Final
				allowSaveNotes={!isReadonly && form.status.id === 3}
				allowNotes={true}
				undoSubmit={this.handleUndoSubmit}
				allowUndoSubmit={allowUndoSubmit}
			/>}
			<ToastContainer theme='colored' />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		entities: { individualConsultationFormResponses },
		auth: { currentUser }
	} = state;

	const form = individualConsultationFormResponses[ownProps.match.params.id];
	const allowUndoSubmit = form && form.status.id === 3 && authUtils.hasPermission(currentUser, 'UndoCompletedForms');

	return {
		form,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationDocuments'),
		currentFormValues: getFormValues('customForm')(state),
		allowUndoSubmit
	};
};

export default connect(mapStateToProps, {
	fetchIndividualConsultationFormResponse,
	updateIndividualConsultationFormResponse,
	undoSubmitIndividualConsultationFormResponse,
	changeFormValue: (field, value) => change('customForm', field, value)
})(withTranslation()(FormDetails));
